import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { fetchWrapper } from "../_helpers";

// create slice
const name = "dashboard";
const initialState = createInitialState();
const reducers = createReducers();
const extraActions = createExtraActions();

const slice = createSlice({
  name,
  initialState,
  reducers,
  extraReducers: (builder) => {
    createExtraReducers(builder);
  },
});

// exports
export const dashboardAction = { ...slice.actions, ...extraActions };
export const dashboardReducer = slice.reducer;

// implementation

function createInitialState() {
  return {
    getDashboardInfo: [],
    getAdminDashboardInfo: [],
    importInmateResponse: {},
    errorDetailsResponse: {},
    loading: false,
  };
}

function createReducers() {
  return {
    clearResponse,
    clearErrorResponse,
    clearimportInmateResponse,
  };

  function clearResponse(state, action) {
    state.dashboardResponce = [];
  }

  function clearErrorResponse(state) {
    state.errorDetailsResponse = {};
  }
  function clearimportInmateResponse(state) {
    state.importInmateResponse = {};
  }
}

function createExtraActions() {
  const baseUrl = `${process.env.REACT_APP_API_URL}/ManagementUser/Dashboard`;
  const baseUrl1 = `${process.env.REACT_APP_API_URL}`;

  return {
    GetDashboardInfo: GetDashboardInfo(),
    ImportInmate: ImportInmate(),
    GetDashboardError: GetDashboardError(),
    GetDashboardNotificationCount: GetDashboardNotificationCount(),
    GetDashboardPUMapDetails: GetDashboardPUMapDetails(),
    MoveInactiveInmatePhotoArchieve: MoveInactiveInmatePhotoArchieve()
  };

  function GetDashboardPUMapDetails() {
    return createAsyncThunk(
      `${name}/GetDashboardPUMapDetails`,
      async ({ publicUserId, inmateId, publicInmateConnection, facilityId }) =>
        await fetchWrapper.get(
          `${baseUrl1}/ManagementUser/Dashboard/GetPublicUserListDetailsDashbord?publicUserId=${publicUserId}&inmateId=${inmateId}&publicInmateConnection=${publicInmateConnection}&facilityId=${facilityId}`
        )
    );
  }

  function GetDashboardNotificationCount() {
    return createAsyncThunk(
      `${name}/GetDashboardNotificationCount`,
      async ({ managementUserID, facilityID }) =>
        await fetchWrapper.get(
          `${baseUrl}/GetDashboardNotificationCount?managementUserID=${managementUserID}&facilityID=${facilityID}`
        )
    );
  }

  function GetDashboardInfo() {
    return createAsyncThunk(
      `${name}/GetDashboardInfo`,
      async (facilityID) =>
        await fetchWrapper.get(
          `${baseUrl}/GetDashboardInfo?facilityID=${facilityID}`
        )
    );
  }

  function ImportInmate() {
    return createAsyncThunk(
      `${name}/ImportInmate`,
      async ({ facilityID, CreatedBy }) =>
        await fetchWrapper.post(
          `${baseUrl}/ImportInmate?facilityID=${facilityID}&CreatedBy=${CreatedBy}`
        )
    );
  }

  function MoveInactiveInmatePhotoArchieve() {
    return createAsyncThunk(
      `${name}/MoveInactiveInmatePhotoArchieve`,
      async ({ facilityID, CreatedBy }) =>
        await fetchWrapper.post(
           `${baseUrl1}/ManagementUser/Photos/MoveInactiveInmatePhotoArchieve?facilityId=${facilityID}`
        )
    );
  }

  function GetDashboardError() {
    return createAsyncThunk(`${name}/GetDashboardError`, async (data) => {
      return await fetchWrapper.post(
        `${baseUrl}/GetDashboardError`,
        data
      );
    });
  }

}

function createExtraReducers(builder) {
  builder
    .addCase(extraActions.GetDashboardInfo.pending, (state) => {
      state.loading = true;
      state.error = null;
    })
    .addCase(extraActions.GetDashboardInfo.fulfilled, (state, action) => {
      state.getDashboardInfo = action.payload;
      state.loading = false;
      state.error = null;
    })
    .addCase(extraActions.GetDashboardInfo.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message;
    })

  builder
    .addCase(extraActions.GetDashboardNotificationCount.pending, (state) => {
      state.error = null;
    })
    .addCase(extraActions.GetDashboardNotificationCount.fulfilled, (state, action) => {
      state.getAdminDashboardInfo = action.payload;
      state.loading = false;
      state.error = null;
    })
    .addCase(extraActions.GetDashboardNotificationCount.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message;
    })


    //// Response for ImpInmate
    .addCase(extraActions.ImportInmate.pending, (state) => {
      state.loading = true;
      state.error = null;
    })
    .addCase(extraActions.ImportInmate.fulfilled, (state, action) => {
      state.importInmateResponse = action.payload;
      state.loading = false;
      state.error = null;
    })
    .addCase(extraActions.ImportInmate.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message;
    })

    //// Move Inactive Inmate Photo Archieve
     .addCase(extraActions.MoveInactiveInmatePhotoArchieve.pending, (state) => {
      state.loading = true;
      state.error = null;
    })
    .addCase(extraActions.MoveInactiveInmatePhotoArchieve.fulfilled, (state, action) => {
      state.InactiveInmatePhotoMerge = action.payload;
      state.loading = false;
      state.error = null;
    })
    .addCase(extraActions.MoveInactiveInmatePhotoArchieve.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message;
    })

    // load Error details
    .addCase(extraActions.GetDashboardError.pending, (state) => {
      state.errorDetailsResponse.loading = true;
      state.error = null;
    })
    .addCase(extraActions.GetDashboardError.fulfilled, (state, action) => {
      state.errorDetailsResponse.loading = false;
      state.errorDetailsResponse = action.payload;
      state.error = null;
    })
    .addCase(extraActions.GetDashboardError.rejected, (state, action) => {
      state.errorDetailsResponse.loading = false;
      state.error = action.error.message;
    });
}
